import { inject, isReactive, isRef, onUnmounted, provide } from "vue"

export function usePane(props = [], options = {}) {
  // Avoid doing anything if we're not in a browser context and not break SSR
  if (!window) {
    console.warn("usePane", "no window")
    return
  }

  // Start with empty object to catch a usePane call without a <Tweakpane> parent
  let { pane } = inject("tweakpane", {})
  if (!pane) pane = window.pane

  if (!pane) {
    console.warn("usePane", "TweakPane.vue not a parent component")
    return
  }

  const { title = "Title", expanded = false } = options

  const folder = pane.addFolder({ title, expanded })
  const config = {}
  folder.config = config
  provide("tweakpane", { pane: folder })

  const setInput = (object, key, options = {}, newFolder) => {
    const f = newFolder ? newFolder : folder
    f.addBinding(object, key, options).on("change", (ev) => {
      config[key] = ev.value
      options.onChange?.(ev)
    })
  }

  const setRefInput = (data) => {
    const { name = "Name", value, options = {} } = data
    setInput(value, "value", { label: name, ...options })
  }

  const setVectorInput = (data, name, options, folder) => {
    const obj = {}
    obj[name] = data
    const entries = Object.keys(data).map((key) => [key, options])
    const keyOptions = Object.fromEntries(entries)
    setInput(obj, name, { label: name, ...options, ...keyOptions }, folder)
  }

  const isVector = (data) => {
    return data.x !== undefined || data.r !== undefined
  }

  const setReactiveInput = (data) => {
    const { name = "", value, options = {} } = data

    if (isVector(value)) {
      // Setup inputs to sit next to each other in a row
      setVectorInput(value, name, options)
    } else {
      const f = name ? folder.addFolder({ title: name }) : null

      Object.entries(value).forEach(([key, val]) => {
        if (typeof val === "object") {
          if (isVector(val)) {
            setVectorInput(val, key, options, f)
          } else {
            const f = folder.addFolder({ title: key })
            Object.entries(val).forEach(([k]) => {
              setInput(val, k, { label: k, ...options }, f)
            })
          }
        } else {
          setInput(value, key, { label: key, ...options }, f)
        }
      })
    }
  }

  props.forEach((prop) => {
    // const { name = 'Name', isPoints = false, options = {} } = prop;
    const { value } = prop

    if (!value) return

    const _isReactive = isReactive(value)
    const _isRef = isRef(value)
    //const _isObject = isRef(value);

    if (_isRef) setRefInput(prop)
    if (_isReactive) setReactiveInput(prop)
  })

  onUnmounted(() => {
    folder.dispose()
  })

  return folder
}
